<template lang="pug">
.file-management-details-wrapper
  .file-and-deadline
    .file
      InputMultipleFiles(
        v-model="info.arquivos"
        label="arquivos"
        :accept="tiposDeArquivoAceitos"
        ref="inputMultipleFiles"
      )
    Validate.prazo(v-model="info.prazo" :minDate="hoje")
      PDatePicker(
        name="prazo"
        label="prazo"
        :minDate="hoje"
      )

  .text-to-select-entity
    span.fs-15.bold(:class="{disabled: !mostraSeletorDeMaisUsuarios}")
      | quais outros usuários precisam aprovar o arquivo?

  .descricao
    PTextField(
      v-model="info.descricao"
      label="descrição (se deixada em branco, será o nome do arquivo anexado)"
      name="descricao"
    )

  .checkbox-for-entity
    PCheckbox(
      label="requisitar aceite de outros usuários além do usuário vinculado"
      v-model="mostraSeletorDeMaisUsuarios"
      @change="resetaUsuarios"
    )

  .text-to-select-user
    span.fs-15.bold a qual usuário deseja vincular o arquivo?

  .select-user
    Validate.select(v-model="info.usuarioVinculado")
      PSelect(
        title="selecionar usuário"
        useCommon="users"
        labelItem="name"
        usaPaginacao
      )

  .aproval-message
    .checkbox
      PCheckbox(label="adicionar mensagem customizada para pedido:" v-model="info.customizaMensagemDeAprovacao" @change="resetaMensagemCustomizada")
    .textfield
      PTextField(
        v-model="info.mensagemCustomizada"
        label=""
        :disabled="!info.customizaMensagemDeAprovacao"
      )

  .entity-content
    PMultiSelect(
      labelItem="name"
      v-model="info.usuariosQueAprovarao"
      title="selecionar usuários"
      useCommon="users"
      :disabled="!mostraSeletorDeMaisUsuarios"
      usaPaginacao
    )

  .entity-options
    //- ENQUANTO NÃO IMPLEMENTA NO BACK

    //- PCheckbox(
    //-   label="enviar notificação por e-mail aos usuários selecionados"
    //-   v-model="info.enviarNotificacaoPorEmail"
    //-   :disabled="!mostraSeletorDeMaisUsuarios"
    //- )
    //- PCheckbox(
    //-   label="receber alerta quando arquivo for aprovado"
    //-   v-model="info.enviarNotificacaoQuandoAprovado"
    //-   :disabled="!mostraSeletorDeMaisUsuarios"
    //- )

  .categoria
    Validate(v-model="info.categoria")
      PSelect(
        title="categoria"
        useCommon="reasons/apenasParaGerenciamentoDeArquivo"
        labelItem="description"
        sortAlphabetically
      )
    .botao-de-nova-categoria
      PButton(
        color="primary"
        size="sm"
        @click="adicionarNovaCategoria"
        title="adicionar nova categoria"
      )
        .icon-ptt-icons-adicionar

  .buttons
    PButton(color="success" size="md" @click="adicionar" :loading="carregandoSalvar" block) adicionar
    PButton(color="danger", size="md", @click="cancelar" :disabled="carregandoSalvar") cancelar
</template>

<script>
import moment from 'moment'
import { useValidationsMixin } from 'src/common/validations'
import InputMultipleFiles from 'src/common/inputs/InputMultipleFiles.vue'

export default {
  name: 'FileManagementDetails',
  props: {
    id: {type: String}
  },
  data () {
    return {
      carregandoSalvar: false,
      mostraSeletorDeMaisUsuarios: false,
      tiposDeArquivoAceitos: 'image/png, image/x-png, image/jpeg, image/jpg, application/pdf',
      hoje: new Date(),
      info: {
        arquivos: [],
        prazo: null,
        descricao: '',
        usuariosQueAprovarao: { selected: [] },
        usuarioVinculado: { selected: null },
        categoria: { selected: null },
        customizaMensagemDeAprovacao: false,
        enviarNotificacaoPorEmail: false,
        enviarNotificacaoQuandoAprovado: false,
        mensagemCustomizada: 'concordar com a validade legal deste documento'
      }
    }
  },
  mounted () {},
  methods: {
    async adicionar () {
      if (!this.isAllValid()) {
        this.displayAllErrors()
        return
      } else if (this.info.arquivos.length === 0) {
        this.$modalDeInformacao('É necessário anexar pelo menos 1 arquivo!')
        return
      } else if (this.mostraSeletorDeMaisUsuarios && this.info.usuariosQueAprovarao.selected.length === 0) {
        this.$modalDeInformacao('Por favor, escolha os usuários que precisam aprovar este documento ou desmarque a opção para requisitar o aceite de outros usuários')
        return
      }

      this.carregandoSalvar = true
      try {
        for (const arquivo of this.info.arquivos) {
          const parametros = {
            descricao: this.info.descricao === '' ? arquivo.name : this.info.descricao,
            dataLimitePedidoUtc: this.info.prazo ? moment(this.info.prazo).format('YYYY-MM-DD') : '',
            arquivo: arquivo,
            categoriaId: this.info.categoria.selected.id,
            acoesDeNotificacao: JSON.stringify(['email']),
            mensagemCustomizada: this.info.mensagemCustomizada,
            usuariosQueAprovarao: JSON.stringify(this.info.usuariosQueAprovarao.selected.map(u => u.email)),
            usuarioVinculado: this.info.usuarioVinculado.selected.email
          }

          const resultado = await this.$API.criarGerenciamentoDeArquivo(parametros)
          console.log(resultado)
        }

        this.$modalDeSucesso('Arquivo(s) adicionado(s) com sucesso!')
        this.$emit('adicionar')
      } catch (e) {
        console.error(e)
        this.$modalDeErro(e?.data?.error ? e.data.error : 'Não foi possível adicionar o(s) arquivo(s). Por favor, tente novamente. Se o erro persistir entre em contato com o suporte.')
      } finally {
        this.carregandoSalvar = false
      }
    },
    cancelar () {
      this.$emit('cancel')
    },
    adicionarNovaCategoria () {
      const routeData = this.$router.resolve({name: 'reason.list'})
      window.open(routeData.href, '_blank')
    },
    resetaUsuarios (novoValor) {
      if (!novoValor) {
        this.info.usuariosQueAprovarao = { selected: [] }
        this.info.enviarNotificacaoPorEmail = false
        this.info.enviarNotificacaoQuandoAprovado = false
      }
    },
    resetaMensagemCustomizada (novoValor) {
      if (!novoValor) {
        this.info.mensagemCustomizada = 'concordar com a validade legal deste documento'
      }
    }
  },
  mixins: [useValidationsMixin({})],
  components: {InputMultipleFiles}
}
</script>

<style lang="scss" scoped>
.file-management-details-wrapper {
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 15px;
  row-gap: 1px;
  grid-template-areas:
    'file-and-deadline categoria'
    'descricao checkbox-for-entity'
    'text-to-select-user text-to-select-entity'
    'select-user entity-content'
    'aproval-message entity-options'
    '. buttons';

  .file-and-deadline {
    grid-area: file-and-deadline;
    display: grid;
    grid-auto-flow: column;
    column-gap: 20px;
  }

  .text-to-select-entity {
    grid-area: text-to-select-entity;
    align-self: start;
  }

  .descricao {
    grid-area: descricao;
    padding-top: 4px;
  }

  .checkbox-for-entity {
    grid-area: checkbox-for-entity;
    align-self: center;
    // padding-bottom: 5px;
  }

  .entity-select {
    grid-area: entity-select;
    align-self: center;
    width: 400px;
  }

  .aproval-message {
    grid-area: aproval-message;

    .textfield {
      padding-left: 20px;
    }
  }

  .text-to-select-user {
    grid-area: text-to-select-user;
    align-self: top;
  }

  .entity-content { grid-area: entity-content; }

  .select-user {
    grid-area: select-user;
    align-self: start;
  }

  .entity-options {
    grid-area: entity-options;
    padding-top: 20px;
  }

  .categoria {
    grid-area: categoria;
    display: grid;
    grid-template-columns: 1fr min-content;
    align-items: end;

    .botao-de-nova-categoria { margin-bottom: 10px; }
  }

  .buttons {
    grid-area: buttons;
    justify-self: end;
    align-self: end;

    display: grid;
    grid-auto-flow: column;
    column-gap: 1px;
  }

  .disabled {
    color: gray;
  }
}
</style>
